<template>
  <div>
    <el-dialog
      id="activity"
      title="编辑vip升级配置"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="350px"
      center
      calss="ac-dialog"
    >
      <div class="ac-dia-form">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          size="mini"
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="vip升级价格" prop="vipUpPrice">
            <el-input v-model.number="ruleForm.vipUpPrice" />
          </el-form-item>
          <el-form-item label="svip升级价格" prop="sVipUpPrice">
            <el-input v-model.number="ruleForm.sVipUpPrice" />
          </el-form-item>
          <el-form-item label="vip升级节省" prop="vipUpCheapPrice">
            <el-input v-model.number="ruleForm.vipUpCheapPrice" />
          </el-form-item>
          <el-form-item label="svip升级节省" prop="sVipUpCheapPrice">
            <el-input v-model.number="ruleForm.sVipUpCheapPrice" />
          </el-form-item>
          <el-form-item label="新手卡倒计时(小时)" prop="timeConfig">
            <el-input v-model.number="ruleForm.timeConfig" />
          </el-form-item>                
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      dialogFormVisible: false,
      ruleForm: {
        id:'',
        vipUpPrice:'',
        sVipUpPrice:'',
        vipUpCheapPrice:'',
        sVipUpCheapPrice:'',
        timeConfig:24
      }
      
    }
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          API.setConfig(this.ruleForm).then(() => {
            this.$emit('handlerChannelList')
            this.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$emit('handlerChannelList')
      this.dialogFormVisible = false
    },
    // 打开编辑视频弹窗
    open(pageData) {
      this.dialogFormVisible = true
      this.ruleForm=pageData
      window.console.log(pageData,'pageData')
    }
  }
}
</script>

<style lang='' scoped>
</style>
